/**
 * Resolve a French UI string via the phrases catalog (hashed keys).
 * Prefer explicit namespaced keys for chrome/hubs; use this for page bodies.
 * Uses the i18next singleton directly (not ./index) to avoid circular imports
 * when tp() is called at module scope.
 */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { PHRASE_KEYS } from './phraseKeys';

/** Translate a phrases:* key (safe at module scope — reads current language).
 * `options` is passed through to i18next for interpolation (e.g. { year }). */
export function tp(key, options) {
  if (!key) return key;
  const full = String(key).startsWith('phrases:') ? key : `phrases:${key}`;
  return i18next.t(full, options);
}

export function useP() {
  const { t } = useTranslation('phrases');
  return useCallback(
    (fr, options) => {
      if (fr == null || fr === '') return fr;
      const key = PHRASE_KEYS[fr];
      if (!key) return fr;
      return t(key, options);
    },
    [t],
  );
}

/** Non-hook: French string → translated (via phraseKeys). `options` = interpolation values. */
export function p(fr, options) {
  const key = PHRASE_KEYS[fr];
  if (!key) return fr;
  return tp(key, options);
}
